import { JwtInterceptor } from './core/interceptor/jwt.interceptor';
import { OverlayModule } from '@angular/cdk/overlay';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { APP_INITIALIZER } from '@angular/core';
//import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
//import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
// import { GlobalEffects, GlobalStore } from './store/global-store.state';

import { ThemeModule } from "./theme/theme.module";
import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';

import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { AdminGuard } from './theme/guard/admin.guard';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { AppInitService } from './core/services/appinit.services';
import { environment } from '../environments/environment';
import { AppInterceptor } from './core/interceptor/app.interceptor';

/* export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
} */


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    OverlayModule,
    ThemeModule,
    HttpClientModule,
    NgbModule,
    RouterModule,
    StoreModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    // EffectsModule.forRoot(GlobalEffects),
    ToastrModule.forRoot(),
    /*TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    }), */
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    LoadingBarModule,
    StoreModule.forRoot(),
    EffectsModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
  ],
  providers: [
    AdminGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: () => addInitFactory, deps: [AppInitService], multi: true },
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }

export function addInitFactory(appInitService: AppInitService) {
  return () => {
    return appInitService.init()
  }
}
